/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.15.0
 * @since 1.15.0
 */

import styled from 'styled-components';

import { fonts } from '../../../../theme';

export const WizardBlockDocStepChooseStyled = styled.div.attrs({
    className: 'wizard-block-doc',
})`
    user-select: none;
    margin-top: 20px;
    max-width: 560px;

    .wizard-block-doc__group-control {
        width: fit-content;
        margin-bottom: 24px;
    }

    .wizard-block-doc__sub-group {
        margin-top: 24px;
        margin-left: 24px;
    }

    .wizard-block-doc__group-row {
        display: flex;
        & > *:not(:last-child) {
            margin-right: 12px;
        }
    }

    .wizard-block-doc__group-column {
        display: flex;
        flex-direction: column;
        & > *:not(:last-child) {
            margin-bottom: 16px;
        }
    }

    .wizard-block-doc__title {
        ${fonts.textMainBold};
        margin-bottom: 12px;
    }
`

export const WizardBlockDocStepConfirmationStyled = styled.div.attrs({
    className: 'wizard-block-doc',
})`
    display: grid;
    grid-template-columns: 1fr 1fr;

    margin-top: 20px;
`;
